import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';

import settings from '../../../../../settings';

import RightSide from '../../../../components/FormArea/RightSide';
import Form from '../../../../components/Form';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import Input from '../../../../components/Inputs/Input';
import Dropdown from '../../../../components/Inputs/Dropdown';
import { faTimes, faSave, faTrash } from '@fortawesome/pro-solid-svg-icons';
import DataContainer from '../../../../logic/dataContainer';

class RightsDetail extends React.Component {
  constructor(props) {
    super(props);

    this.rightGuid = props.match.params.id;
    this.parentRoute = this.props.match.url.replace(new RegExp(`/${this.rightGuid}$`), '');

    this.state = {
      loading: true,
    };

    const GetRight = reqwest({
      method: 'GET',
      url: settings.permissions.GetPermission,
      contentType: 'JSON',
      data: {
        Token: localStorage.getItem('token'),
        Guid: this.rightGuid,
      },
    }).then(rightResponse => {
      this.dataContainer = new DataContainer(rightResponse);
    });

    const getApplicationSectionsPromise = reqwest({
      method: 'GET',
      url: settings.permissions.GetApplicationSections,
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(applicationSectionsResult => {
      this.sectionContainer = new DataContainer(applicationSectionsResult);
      applicationSectionsResult = JSON.parse(applicationSectionsResult);

      this.setState({
        sections: applicationSectionsResult.map(section => ({
          value: section.Params.Guid,
          label: section.Params.Name,
        })),
      });
    });

    Promise.all([GetRight, getApplicationSectionsPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Überprüfung fehlgeschlagen!',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben.',
      });
      return;
    }

    const Right = this.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.permissions.AddRight,
      data: {
        Token: localStorage.getItem('token'),
        Right,
      },
    }).then(saveResult => {
      saveResult = JSON.parse(saveResult);

      if (saveResult[0].Params.SaveResult === 'Updated') {
        swal({
          title: 'Erfolg!',
          text: 'Das Recht wurde erfolgreich angelegt.',
          icon: 'success',
        });
        this.props.history.replace(this.parentRoute);
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <Form ref={node => (this.form = node)}>
            <ContentBox title='Recht'>
              <Input
                type='text'
                label='Name:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.dataContainer.set('Entry', 'Name')(value);
                }}
                defaultValue={this.dataContainer.get('Entry', 'Name')}
                name='Name'
              />
              <Input
                type='text'
                label='Bemerkung:'
                validator={[]}
                onChange={value => {
                  this.dataContainer.set('Entry', 'Bemerkung')(value);
                }}
                defaultValue={this.dataContainer.get('Entry', 'Bemerkung')}
                name='Bemerkung'
              />
              <Dropdown
                label='Anwendungssektion:'
                fullWidth
                isSearchable
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                getSelected={value => {
                  this.dataContainer.set('Entry', 'Section')(value);
                }}
                defaultValue={this.dataContainer.get('Entry', 'Section')}
                options={this.state.sections}
                name='Section'
              />
            </ContentBox>
          </Form>
        </div>
        <RightSide>
          <Button big type='danger' icon={faTrash} onClick={this.delete}>
            Löschen
          </Button>
          <Button big icon={faTimes} to={this.parentRoute}>
            Abbrechen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default RightsDetail;
